define('app/factories/vendor_rating_form_factory',['app/setup', 'app/views/vendor_rating_form_view'],
  function (takhfifan, vendorRatingFormView) {
    var alreadyInitializedView = false;

    function initView(){
      if(takhfifan.formKey && !alreadyInitializedView){
        $('.tkh-vr-form').each(function () {
          new takhfifan.VendorRatingFormView({
            el: $(this)
          });
        });
      }
    }

    initView();

    takhfifan.eventHub.on('formkey', function(formKey) {
      initView();
    });
  });




